import { message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export interface AulaDatabase {
    id: number;
    id_aula: number;
    id_professor: number;
    nom: string;
    schema_name: string;
    created_at?: string;
    professor_nom?: string;
}

export const GetAulaDatabases = async (idAula: string | number): Promise<AulaDatabase[]> => {
    try {
        const token = localStorage.getItem("token") || "";
        const response = await fetch(`${apiUrl}:8061/bbdd/aules/${idAula}/databases`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.error || "Error en obtenir les bases de dades de l'aula");
        }
        return await response.json();
    } catch (error: any) {
        console.error("GetAulaDatabases error:", error);
        return [];
    }
};

export const PostAulaDatabase = async (idAula: string | number, name: string): Promise<any> => {
    try {
        const token = localStorage.getItem("token") || "";
        const response = await fetch(`${apiUrl}:8061/bbdd/aules/${idAula}/databases`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ name })
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data?.error || "Error creant la base de dades");
        }
        return data;
    } catch (error: any) {
        message.error(error.message || "Error al crear la base de dades");
        throw error;
    }
};

export const DeleteAulaDatabase = async (idAula: string | number, idDatabase: number): Promise<boolean> => {
    try {
        const token = localStorage.getItem("token") || "";
        const response = await fetch(`${apiUrl}:8061/bbdd/aules/${idAula}/databases/${idDatabase}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.error || "Error esborrant la base de dades");
        }
        return true;
    } catch (error: any) {
        message.error(error.message || "Error al esborrar la base de dades");
        throw error;
    }
};

